// DropdownMenu.tsx

import React, { ReactNode } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/system';

interface DropdownMenuProps {
  anchorEl: HTMLElement | null;
  menuItems?: { label: string | ReactNode; onClick: () => void }[];
  langItems?: { label: string; onClick: () => void }[];
  onClose: () => void;
  hoverColor?: string;
}

const StyledMenu = styled(Menu)({
  '& .MuiMenu-paper': {
    backgroundColor: 'white',
    color:"black",
    borderRadius: '5px',
    marginTop: '20px',
  },
});

const StyledMenuItem = styled(MenuItem)<{ hoverColor?: string }>`
  &:hover {
    background-color: ${(props) => props.hoverColor || '#4C0055'} !important;
  }
`;

const DropdownMenu: React.FC<DropdownMenuProps> = ({ anchorEl, menuItems,langItems, onClose, hoverColor }) => {
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {menuItems?.map((menuItem, index) => (
        <StyledMenuItem className=' hover:text-white font-Saira font-[500] text-[13px]' hoverColor={hoverColor} key={index} onClick={() => {menuItem.onClick(); onClose();}}>
          {menuItem.label}
        </StyledMenuItem>
      ))}
      {langItems?.map((langItem, index) => (
        <StyledMenuItem className=' hover:text-white font-Saira font-[500]' hoverColor={hoverColor} key={index} onClick={() => {langItem.onClick(); onClose();}}>
          {langItem.label}
        </StyledMenuItem>
      ))}
    </StyledMenu>
  );
};

export default DropdownMenu;